import Paragraph from "~/componentsDS/Typography/Paragraph";
import { cn } from "~/lib/utils";

interface PillProps {
    text: string;
    quoted?: boolean;
    className?: string;
}

const Pill = ({ text, quoted = true, className }: PillProps) => {
    return (
        <div className={cn(
            "inline-flex items-center gap-[14px] h-fit px-3 py-2 md:py-3 text-pureWhite bg-trueBlack/25 backdrop-blur-[25px] rounded-full",
            className
        )}>
            <div className="w-2.5 h-2.5 bg-secondary300 rounded-full shrink-0" />
            <Paragraph weight="500">{quoted ? `"${text}"` : text}</Paragraph>
        </div>
    );
};

export default Pill;
